module.exports = __webpack_public_path__ + "assets/81115fe23988bf1f5a2b865ccec46c59.png";